// extracted by mini-css-extract-plugin
export var avatar = "_8-6";
export var brandLink = "_8-0";
export var brandLogo = "_8-1";
export var gear = "_8-7";
export var gearActive = "_8-8";
export var navIcon = "_8-5";
export var navItem = "_8-3";
export var navItemActive = "_8-4";
export var sectionLabel = "_8-2";